// src/components/Dashboard/AttorneyExportButton.jsx
//
// Botón "Expediente para abogado": junta notas, agenda, pasos, closings,
// adjuntos y documentos firmados del reclamo y descarga un ZIP
// (documents/attorneyExport.js). Solo equipo CSR.
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { buildAttorneyZip } from '../../documents/attorneyExport';
import { getClaimNotes } from '../../services/claimNoteService';
import { getClaimEvents } from '../../services/claimEventService';
import { getFlowHistory } from '../../services/flowService';
import { listClosings } from '../../services/closingService';
import { getAllAttachmentFiles, getAllAttachmentFolders } from '../../services/attachmentService';
import { fetchBackupBlob } from '../../services/backupService';

const safe = value => String(value || '').replace(/[\\/:*?"<>|]+/g, '').trim();

const AttorneyExportButton = ({ claimRecord, language }) => {
  const es = language === 'es';
  const [busy, setBusy] = useState(false);

  const exportFile = async () => {
    setBusy(true);
    try {
      const [notes, events, history, closings, folders, files] = await Promise.all([
        getClaimNotes(claimRecord.id), getClaimEvents(claimRecord.id), getFlowHistory('claim', claimRecord.id),
        listClosings(claimRecord.id), getAllAttachmentFolders(claimRecord.id), getAllAttachmentFiles(claimRecord.id)
      ]);
      const { blob, included, failed } = await buildAttorneyZip({ claimRecord, notes, events, history, closings, folders, files, fetchFile: fetchBackupBlob });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Expediente - ${[safe(claimRecord.clientName), safe(claimRecord.claimNumber)].filter(Boolean).join(' - ')}.zip`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      if (failed.length) {
        toast.error(es ? `Expediente descargado, pero ${failed.length} archivo(s) no se pudieron incluir (ver LEEME.txt).` : `Downloaded, but ${failed.length} file(s) could not be included (see LEEME.txt).`);
      } else {
        toast.success(es ? `Expediente descargado (${included} archivo(s) + cronología).` : `File downloaded (${included} file(s) + timeline).`);
      }
    } catch (error) {
      console.error('Error building attorney export:', error);
      toast.error(es ? 'No se pudo armar el expediente' : 'Could not build the file');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button type="button" className="cd-btn cd-btn-invoice" onClick={exportFile} disabled={busy}>
      <i className={`fa-solid ${busy ? 'fa-spinner fa-spin' : 'fa-file-zipper'}`}></i> {busy ? (es ? 'Armando expediente…' : 'Building file…') : (es ? 'Expediente para abogado (ZIP)' : 'Attorney file (ZIP)')}
    </button>
  );
};

export default AttorneyExportButton;
